import { api } from './api';
import config from 'data/config';

import { jwtDecode } from 'jwt-decode';

const baseUrl = config.authServiceUrl;
const mdsBaseUrl = config.masterDataServiceURL;

// A mutation is used instead of a query in getCompany and getCompanyFeatures
// because the data is not being cached as we are simply passing the user on
// to the dashboard following login. The mutation also allows us to call the
// function directly in the login function without violating rules of hooks
// or needing to store the token in state.
export const loginApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompany: build.mutation({
      query: ({ siteId, token }) => {
        return {
          url: `${mdsBaseUrl}/api/company?includeNonCentralized=true&idType=SiteId&idList=${siteId}`,
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      transformResponse: async (res) => {
        const data = { companyId: res[0]?.id };

        return data;
      },
    }),
    getCompanyFeatures: build.mutation({
      query: ({ token, companyId }) => {
        return {
          url: `${mdsBaseUrl}/api/company/features?companyId=${companyId}`,
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      transformResponse: async (res) => {
        // The id for the WFH feature is 21, so we return the array element with that id.
        // Then if the feature exists we determine if it is enabled.
        const WFHFeature = res.filter((el) => el.id === 21);
        const [SelfServiceFeature] = res.filter((el) => el.id === 45);
        const data = {
          hasWFHEnabled: WFHFeature[0]?.enabled ?? false,
          isSelfServiceEnabled: SelfServiceFeature?.enabled ?? false,
        };

        return data;
      },
    }),
    postLogin: build.mutation({
      query: ({ body }) => {
        return {
          url: `${baseUrl}/UnifiedCredentialsGrant/Login`,
          method: 'POST',
          body,
        };
      },
      transformResponse: async (res) => {
        let roles = [];
        const { result: { jwt = '' } = {} } = res || {};
        if (jwt) {
          const decoded = jwtDecode(jwt);
          roles = decoded.roles;
        }

        const data = {
          token: res?.result?.jwt,
          siteId: res?.result?.info?.site?.id,
          roles,
        };

        return data;
      },
    }),
    postForgotPassword: build.mutation({
      query: ({ body }) => {
        return {
          url: `${mdsBaseUrl}/api/employee/emailPasswordReset`,
          method: 'POST',
          body,
        };
      },
      transformResponse: async (res) => {
        console.log('Transform Password Reset: ', res);

        return res;
      },
    }),
    postPartnerLogin: build.mutation({
      query: ({ body }) => {
        return {
          url: `${baseUrl}/OwnerCredentialsGrant/GetLogin`,
          method: 'POST',
          body,
          headers: {
            'x-api-version': '2018-02-18',
          },
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCompanyMutation,
  useGetCompanyFeaturesMutation,
  usePostLoginMutation,
  usePostForgotPasswordMutation,
  usePostPartnerLoginMutation,
} = loginApi;
